import { createContext, useContext } from "react";

// Lets popovers portal into a surrounding container (e.g. a sheet) instead of document.body.
// Inside the container they don't need to be modal to be scrollable and clickable, so a tap
// outside them still reaches whatever was tapped.
export const PortalContainerContext = createContext<HTMLElement | undefined>(undefined);

export const usePortalContainer = (): HTMLElement | undefined => useContext(PortalContainerContext);
